"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CookiesDetailsModal;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("Modals/ModalTools/Modal"));
var _CookieInfos = _interopRequireDefault(require("Components/Cookies/CookieInfos"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _CookiesStore = _interopRequireDefault(require("Components/Stores/CookiesStore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function CookiesDetailsModal({
  onClose,
  ...props
}) {
  const ref_close = (0, _react.useRef)();
  const ref_open = (0, _react.useRef)();
  const is__open = _CookiesStore.default.useState(s => s.open === true);
  (0, _react.useEffect)(function () {
    ref_open.current = false;
    ref_close.current = onClose;
  }, [onClose]);
  (0, _react.useEffect)(function () {
    if (!is__open && !ref_open.current) return () => void 0;
    ref_open.current = is__open;
    if (!is__open) ref_close.current?.();
  }, [is__open]);
  const closeModal = (0, _react.useCallback)(function (e) {
    _CookiesStore.default.update(function (store) {
      store.open = false;
    });
  }, []);
  const footer = /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    "aria-label": "Fermer",
    className: (0, _bemit.default)('c-button'),
    onClick: closeModal
  }, "Fermer");
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    open: is__open,
    onClose: closeModal,
    bemit: ['cookies-details', 'simple'],
    trg: props.trg,
    title: "Param\xE8tres de confidentialit\xE9",
    footer: footer
  }, /*#__PURE__*/_react.default.createElement(_CookieInfos.default, {
    code: "google_analytics"
  }));
}
